import getAdminSettings from "../getAdminSettings";

/**
 * Flight fees settings live on GET /payment/v1/setting/admin
 * (legacy /payment/v1/fee/get was removed).
 */
export default async function getFees() {
  return getAdminSettings();
}
